export default {
  assembly: {
    contactProperties: '接觸屬性',
    convergenceAdvanced: '收斂（進階）',
    allowCutbacks: '允許增量回切',
    allowCutbacksHint:
      '預設關閉：無法收斂的步驟會立即失敗，而不會以更小的荷重增量重試。僅在預期求解困難而非設定錯誤時開啟 — 失敗可能耗時甚久。',
    cutbacksDisabled: '停用 — 快速失敗',
    cutbacksEnabled: '啟用 — 以較小增量重試',
    friction: '摩擦係數 μ（0–2）',
    frictionTooltip:
      '庫侖摩擦可傳遞剪力，最大為 μ 乘以目前接觸壓力。留空或填 0 表示無摩擦，表面可自由滑動。',
    normalStiffness: '法向剛度（MPa/mm）',
    normalStiffnessTooltip:
      '懲罰剛度會在表面接觸時抵抗法向穿透。有限剛度允許極小的數值重疊；留空時由材料剛度推導。',
    stickSlope: '黏著斜率（MPa/mm）',
    stickSlopeTooltip:
      '控制剪應力隨相對切向位移增加的速度。剪力約在 μp 以下時保持黏著，超過後滑動。留空時使用 K/100。',
    contactDefaults:
      '摩擦留空表示無摩擦；剛度留空由求解器推導。剛度必須為正值，黏著斜率需明確指定摩擦係數。',
    shrinkTitle: '熱收縮預緊',
    shrinkHint:
      '以虛構溫降對緊固件本體施加等效安裝夾緊力——這不是熱傳求解，也不會讀取 thermal_conduction 溫度場。請指定力與軸向。截面表面為選填，僅用於校正實際輸出的力；此設定不模擬鉚接成形，也不會建立截面。',
    unnamed: '未命名預緊',
    name: '名稱',
    body: '緊固件本體',
    chooseBody: '選擇本體',
    force: '目標預緊力（N）',
    boltGrade: '螺栓性能等級',
    boltGradeNone: '未指定',
    boltGradeHint: '設定預緊裕度所使用的保證應力。',
    areaMode: '桿部模型',
    threaded: '公制螺紋',
    smooth: '光滑桿部／鉚釘',
    area: '桿部面積（mm²）',
    size: '公制尺寸（M3–M36）',
    axis: '{{axis}} 軸分量',
    section: '截面表面（選填）',
    sectionNone: '未指定（未校正）',
    sectionEmpty:
      '此網格未提供任何截面表面。求解檔會排除內部表面，而桿部中段平面無法在 CAD 中標記，因此緊固組件通常沒有可用的截面。請保持未指定。',
    sectionUncalibrated:
      '未指定截面表面時，熱收縮不會對照實測力進行校正。實際預緊力預期會比目標值低約 15–25%。',
    remove: '移除 {{name}}',
    addShrink: '新增熱收縮預緊',
    invalid:
      '請填寫預緊名稱、本體、正向力、非零軸向及桿部面積或公制尺寸。接觸剛度須為正值，摩擦係數須介於 0 與 2。',
  },
  bc: {
    velocityInlet: '速度入口',
    pressureOutlet: '壓力出口',
    wallNoSlip: '壁面（無滑移）',
    slip: '滑移',
    symmetry: '對稱',
    freestream: '自由流',
    unset: '選擇流向',
    groups: {
      unset: '需要選擇流向',
      inlet: '入口',
      outlet: '出口',
      farfield: '自由流',
      symmetry: '對稱',
      wall: '壁面',
    },
    short: {
      inlet: '入口',
      outlet: '出口',
      wall: '壁面',
      slip: '滑移',
      symmetry: '對稱',
      freestream: '自由流',
      unset: '未設定',
    },
  },
  boundaryConditions: {
    untaggedTitle: '網格尚未標記',
    untaggedDescription:
      '所選網格尚未有具名的面片。以下是幾何自動偵測到的開口（唯讀）。將游標移到某列以在檢視器中反白對應的面；在 MeshGen 中標記它們即可在此進行物理指定。',
    tagInMeshgen: '在 MeshGen 中標記',
    faceIndex: '面 {{index}}',
    selectForBulk: '選取 {{name}} 以批次重新指定',
    editPatchName: '編輯面片名稱',
    rename: '重新命名 {{name}}',
    blBadgeTooltip:
      '來自 MeshGen 邊界層面板的稜柱牆面片。預設為牆面物理；若應套用不同邊界條件，重新指定角色後它會移至該群組。',
    bodyWallTooltip:
      '整體本體牆面 — 所有未單獨標記為面片的本體表面（例如邊界層面）。合併為一個無滑移面片；選取它會反白整個本體表面。',
    bodyWallAria: 'body_wall 是什麼？',
    facesCount: '{{count}} 個面',
    velocityLockedTitle:
      '已鎖定 — 此值來自上方全研究的入口速度掃掠（每次執行套用一個值）。',
    velocityTitle:
      '入口速度大小 [m/s]，沿研究的流動軸 ({{axis}}) 均勻套用。對於標準外流域盒，這即為自由流速度。未針對面片方向修正 — 若入口不垂直於 {{axis}}，有效法向分量為 v·cos(角度)。',
    pressureLockedTitle:
      '已鎖定 — 此值來自上方全研究的出口壓力掃掠（每次執行套用一個值）。',
    pressureTitle:
      '出口錶壓 — 相對於環境，而非絕對壓力。輸入 100 Pa 表示比環境高 100 Pa，而非絕對 100 Pa。預設 0 = 出口等於環境壓力。以運動學形式儲存（p/ρ，單位 m²/s²）；當你輸入 Pa/kPa/psi 時前端會除以流體密度。不可壓縮 NS 僅求解壓力差，因此這設定的是基準值。',
    gaugeLabel: '錶壓',
    gaugeHint: '，相對於環境。0 = 出口等於環境壓力。',
    patchNamingConvention: '面片命名慣例',
    patchNamingBody:
      '求解器寫出網格面片時會加上 {{prefix}} 前綴，並將多面標記分割為 {{suffix000}}/{{suffix001}} 後綴。上方顯示的名稱是你的 meshgen 標籤 — 若執行時出現「面片名稱與網格不符」的失敗，請確認你已在 MeshGen 的邊界指定中標記所有外部表面。',
    emptyMesh:
      '在 MeshGen 中開啟邊界指定以命名你的表面區域。這些名稱會在此顯示以供物理指定。',
    assignPhysics: '為每個網格面片指定物理。點選某列以反白其面。',
    viewerHint:
      '檢視器正顯示 CAD 三角網格以供面預覽 — 使用檢視器角落的檢視下拉選單切換為網格單元檢視。',
    selectedCount: '已選取 {{count}} 個',
    assignRolePlaceholder: '指定邊界屬性…',
    clear: '清除',
    selectAllGroup: '全選 {{group}}',
    selectCategoryInGroup: '全選 {{group}} 中的{{category}}',
    showGroupInViewer: '在檢視器中顯示 {{group}}',
    hideGroupInViewer: '在檢視器中隱藏 {{group}}',
    boundaryLayerFaces: '邊界層面',
    wall: '牆面',
    studyWideVelocitySweep_one:
      '全研究入口速度掃掠 — {{count}} 個值（一個共用值，於上方 Inlet · Velocity 設定），非逐面片掃掠。',
    studyWideVelocitySweep_other:
      '全研究入口速度掃掠 — {{count}} 個值（一個共用值，於上方 Inlet · Velocity 設定），非逐面片掃掠。',
    studyWidePressureSweep_one:
      '全研究出口壓力掃掠 — {{count}} 個值（一個共用值，於上方 Outlet · Pressure 設定），非逐面片掃掠。',
    studyWidePressureSweep_other:
      '全研究出口壓力掃掠 — {{count}} 個值（一個共用值，於上方 Outlet · Pressure 設定），非逐面片掃掠。',
  },
  thermal: {
    labelAdiabatic: '絕熱',
    labelFixedTemperature: '固定溫度',
    labelHeatFlux: '熱通量',
    labelConvection: '對流',
    labelRadiation: '輻射',
    conditionHelp: '{{condition}} 的物理意義',
    helpAdiabatic: '此表面的法向熱通量為零；其他表面仍可交換熱量。',
    helpFixedTemperature:
      '求解器將表面維持在指定溫度；所需熱量是計算結果，而非指定的熱率。',
    helpHeatFlux:
      '指定單位面積的熱通量（W/m²）。正值表示熱量流入該面；負值表示熱量被抽出。',
    bulkAssignPlaceholder: '設定條件…',
    helpConvection:
      '透過膜係數 h 與周圍流體交換熱量；依表面和環境溫度，熱可流入或流出。',
    helpRadiation:
      '與環境交換熱輻射。表面同時發射及吸收；淨熱流取決於放射率及兩者溫度的四次方。',
    hint: '為網格上的每個 CalculiX 面指定熱條件。未標記的面保持絕熱。',
    faceConditions: '表面熱條件（{{count}}）',
    noFaces:
      '尚無 CalculiX 面 — 請在 MeshGen 標記面，或選擇會匯出 calculix_surfaces 的網格。',
    temperature: '溫度',
    heatFlux: '熱通量',
    convectionH: '對流係數 h',
    ambientTemperature: '環境溫度',
    emissivity: '放射率',
    volumeSourceDisabled: '體積發熱率 — 即將推出。',
    pointHeatTitle: '節點熱負載',
    pointHeatHint:
      '將總熱功率施加至指定網格節點。重新劃分網格後請確認節點 ID。',
    pointNode: '網格節點 ID',
    pointPick: '在網格上選取',
    pointPickCancel: '取消選取',
    pointPickHint:
      '將游標移至表面元素可預覽最近的節點，點擊後使用其確切的網格節點 ID。選取期間檢視器會由 CAD 鑲嵌切換為求解網格。',
    pointPower: '功率 (W)',
    pointAdd: '新增節點負載',
    pointRemove: '移除節點熱負載',
    tieSection: '束縛介面',
    createTie: '以束縛接合',
    tieHint:
      '束縛會讓兩面溫度相等，使獨立網格物體之間能傳熱。先選的面是從屬（從）側 — 建議選較細的網格。',
    tieSwap: '交換 {{name}} 的從屬側',
    tieSwapShort: '交換',
    tieRemove: '移除束縛 {{name}}',
    tieDirectionHint: '從屬（從）→ 獨立（主）',
    tieTolerance: '位置公差',
    tieToleranceFor: '{{name}} 的位置公差',
    independentBodiesNeedTie:
      '有 {{count}} 個獨立網格物體尚未設定熱束縛。請將接觸面束縛接合，或以共享節點重新網格，否則熱無法在物體間傳遞。',
    categoryTemperature: '固定溫度',
    categoryTemperatureHottest: '最高溫度',
    categoryTemperatureHotter: '偏高溫度',
    categoryTemperatureColder: '偏低溫度',
    categoryTemperatureColdest: '最低溫度',
    rankHottest: '最高',
    rankHotter: '偏高',
    rankColder: '偏低',
    rankColdest: '最低',
    detailFixedTemperature: '固定溫度',
    detailBonded: '接合',
    detailHeatFlux: '熱通量',
    detailPointHeatLoad: '節點熱負載',
    detailConvection: '對流',
    detailRadiation: '輻射',
    detailNode: '節點',
    categoryHeatFlux: '熱通量',
    categoryHeatPoint: '節點熱負載',
    categoryConvection: '對流',
    categoryRadiation: '輻射',
    categoryTiedInterface: '束縛介面',
  },
  cht: {
    labelAdiabatic: '絕熱',
    labelFixedTemperature: '固定溫度',
    labelConvection: '對流',
    labelSurfaceHeatFlux: '表面熱通量',
    chipFixedT: '固定溫度 {{value}} K',
    chipConvection: '對流（環境空氣）',
    convectionAmbientHint: '紫色＝對環境空氣（周圍）散熱，不是對流體。',
    chipHeatFlux: '熱通量 {{value}} W/m²',
    chipAdiabatic: '絕熱',
    facesCount: '{{count}} 個面',
    chipVelocityInlet: '速度入口',
    fluidInletVelocity: '流體入口速度',
    fluidInletVelocityInfo: '沿流動軸的入口速度大小。',
    inletTemperature: '入口溫度',
    inletTemperatureInfo: '進入域的流體溫度。',
    chipReferenceOutlet: '參考出口 (0 Pa)',
    referenceOutletBody:
      '固定參考出口：錶壓固定為 0 Pa。使用近乎不可壓縮液體的穩態 CHT 在速度入口/參考出口的設定下是良定的 — 開放可調的出口壓力只會位移相同的流動基準值，而不改變解。',
    chipCoupled: '耦合',
    chipSolidFluidInterface: '固↔流體介面',
    expand: '展開',
    collapse: '收合',
    interfaceHeatPathHint:
      '綠色＝固↔流體接觸（熱傳入冷卻液）。外側紫色是環境空氣，不是此介面。',
    interfaceReadOnlyBody:
      '耦合介面由求解器管理，此處沒有可編輯的對流／熱通量類型。請在「流體域」設定流體邊界條件，並在紫色外表面列設定對環境的對流。',
    interfaceExplainerLabel: '關於此固–流體介面',
    interfaceExplainer:
      '此列是耦合網格塊「{{patch}}」。網格器把固體與冷卻液接觸的面合併成一塊，熱才能穿過。這裡不能指定邊界條件。將游標移到或點擊此列即可在檢視器中標出對應的面。',
    interfaceSolidK: '{{region}} ({{material}}) · k {{k}} W/(m·K)',
    interfaceFluidK: '{{region}} ({{material}}) · k {{k}} W/(m·K)',
    interfaceSolidMaterial: '{{region}} · {{material}}',
    interfaceFluidMaterial: '{{region}} · {{material}}',
    interfaceFaceList: '本體面：{{faces}}',
    exteriorFaceList: '外露面：{{faces}}',
    interfaceVolumeLabel: '體積 {{index}}',
    interfaceVolumeOther: '其他面',
    volumeFacesChip: '{{label}} · {{count}} 個面',
    faceListToggle: '面清單 · {{count}}',
    chipNoSlipWall: '無滑移壁面',
    chipSlipWall: '滑移壁面',
    fluidWallNoSlipHint: '冷卻液貼附此壁（無滑移）。CHT 不能把此塊改成滑移壁。',
    fluidWallExplainerLabel: '關於此冷卻液壁',
    fluidWallExplainer:
      '這是流體區域的壁面塊。求解器一律寫入無滑移，壁面速度為零。CHT 沒有滑移壁選項 — 遠場滑移只用在外流。',
    fluidWallReadOnlyBody:
      '浸潤的冷卻液壁必須無滑移。材料或開口請在其他列變更；此塊類型不可編輯。',
    chipOpeningUnassigned: '未設定方向',
    openingRoleInfo:
      '冷卻液是從這個開口流入，還是從這裡流出？網格器找得到開口，但無法判斷流動方向，只有你能指定。',
    openingUnassigned: '不使用 — 封起來',
    openingInlet: '冷卻液從這裡進入',
    openingOutlet: '冷卻液從這裡離開',
    openingUnassignedBody:
      '這個開口會當成實體壁面處理，就像被塞住一樣。若是想封閉的加注口，這是合理的選擇 — 但至少要有一個開口讓冷卻液進入、一個讓它離開，否則沒有任何東西在驅動流動。',
    openingInletShared:
      '速度與溫度由所有標記為進口的開口共用 — 流入的只有一道流，不是每個開口各自一道。',
    power: '功率',
    powerInfo:
      '進入此面的總熱功率。前端除以面片面積以推導下方的通量；提交的是通量。',
    flux: '通量',
    fluxInfo: '表面熱通量。正值 = 熱流入固體；負值 = 表面冷卻。',
    noArea: '無面積',
    powerDisabled:
      '面片面積無法取得 — 功率輸入已停用。請直接設定通量，或選擇 face_tags 帶有面積資料的網格。',
    patchArea: '面片面積：{{area}} cm²',
    solidFaceType: '固體面邊界類型',
    solidFaceTypeInfo:
      '絕熱 = 完全絕緣的面。固定溫度 = 表面維持在目標溫度。對流 = 透過對流係數 h 與環境進行熱交換。',
    temperature: '溫度',
    temperatureInfo: '表面溫度固定於此值。',
    convectionCoefficient: '對流係數',
    convectionCoefficientInfo:
      '熱傳係數 h。自然空氣約 5，強制空氣約 50，水約 1000+，沸騰約 10k+。',
    ambientTemperature: '環境溫度',
    ambientTemperatureInfo: '遠離表面的自由流溫度。',
    adiabaticBody: '此面無熱通量 — 完全絕緣。',
    emptyPatches:
      '為每個網格面片指定熱與流動物理。在 MeshGen 中標記網格的表面區域 — 它們會在此以個別列顯示。',
    assignPhysics:
      '為每個網格面片指定熱與流動物理。點選某列以在檢視器中反白其面。',
  },
  draftSetup: {
    stepPhysics: '物理與邊界條件',
    stepStudy: '研究設計',
    geometries: '幾何',
    addGeometry: '新增幾何',
    inputs: '輸入',
    meshInputsKeepSettings:
      '既有的網格輸入會保留其已儲存的網格設定。若要設定即時網格化，請將輸入類型切換為幾何。',
    parameters: '參數',
    boundaryConditions: '邊界條件',
    facesFromMesh: '面已在 MeshGen 設定',
    facesFromMeshTooltip:
      '入口、出口與壁面已在 MeshGen 命名並隨網格帶入。請在此設定物理數值；若要變更面，請在 MeshGen 重新產生網格。',
    setBcBeforeRunning: '執行前請至少設定一個邊界條件。',
    solverSettings: '求解器設定',
    run: '執行',
    sectionMesh: '網格',
    sectionSimulate: '模擬',
    starting: '啟動中…',
    runStudy: '執行研究',
    continueToSimulate: '繼續至模擬',
    exceededCap: '{{rows}} 個設計點超出 {{cap}} 列上限 — 請減少掃掠或輸入',
    largeStudy: '{{count}} 個設計點 — 大型研究可能需要一段時間',
    failedToRun: '執行研究失敗',
    fileKind: '檔案類型',
    geometriesToggle: '幾何',
    meshesToggle: '網格',
    hideEnclosure: '隱藏包圍盒',
    showEnclosure: '顯示包圍盒',
    enclosure: '包圍盒',
    chtSummary: 'CHT · {{flow}} · {{runs}}',
    cfdSummary: '{{parameters}} · {{flow}} · {{runs}}',
    meshInReason: {
      noGeometry: '請至少加入一個幾何。',
      unmeshed_one: '{{count}} 個幾何仍需完成網格。',
      unmeshed_other: '{{count}} 個幾何仍需完成網格。',
      processing_one: '{{count}} 個幾何仍在準備中（診斷或修復）。',
      processing_other: '{{count}} 個幾何仍在準備中（診斷或修復）。',
      needsAttention_one: '{{count}} 個幾何需要你先處理才能產生網格。',
      needsAttention_other: '{{count}} 個幾何需要你先處理才能產生網格。',
      templateMismatch_one:
        '已選取的 {{count}} 個網格是為其他模擬類型建立的。請為此研究重新產生網格，或取消選取。',
      templateMismatch_other:
        '已選取的 {{count}} 個網格是為其他模擬類型建立的。請為此研究重新產生網格，或取消選取。',
      patchMismatch:
        '各網格的 patch 名稱不一致——請在每個幾何上為相同區域（inlet/outlet/wall）命名。',
    },
    templateSummary: '{{parameters}} · {{template}} · {{runs}}',
    labelSummary: '{{label}} · {{runs}}',
    runsMobo: '{{count}} 次執行 · MOBO',
    runsFitOnly: '{{count}} 次執行 · 僅擬合',
    runs: '{{count}} 次執行',
    paramValue: '{{count}} 個值',
    paramList: '{{count}} 個清單',
    paramRange: '{{count}} 個範圍',
  },
  objectives: {
    title: '目標',
    sobolSamples: 'Sobol 樣本數',
    count: '{{count}} / {{max}}',
    emptyHint:
      '至少新增 {{min}} 個目標以執行多目標最佳化。留空則對設計空間取樣而不進行最佳化。',
    belowMin:
      'MOBO 需要 ≥{{min}} 個目標 — 在新增第二個目標前，執行會退回僅代理擬合。',
    addObjective: '新增目標',
    addAnother: '再新增一個',
    advanced: '進階',
    maxIterations: '最大迭代次數',
    candidatesPerIter: '每次迭代候選數',
    selectMetric: '選擇指標',
    unsupportedMetric: '{{key}}（不支援）',
    notApplicableMetric: '{{label}}（不適用於此案例）',
    undeterminedMetric: '{{label}}（尚無法判斷）',
    farFieldObjective_one:
      '1 個目標不適用：此案例是遠場箱體中的物體，壓降與損失係數量測的是箱體而非零件。必須先修改才能執行研究。請改用力或力係數。',
    farFieldObjective_other:
      '{{count}} 個目標不適用：此案例是遠場箱體中的物體，壓降與損失係數量測的是箱體而非零件。必須先修改才能執行研究。請改用力或力係數。',
    undeterminedObjective_one:
      '目前還無法判斷此案例是流道還是遠場箱體中的物體，因此 1 個壓降目標可能沒有意義。請先設定邊界條件或選擇網格。',
    undeterminedObjective_other:
      '目前還無法判斷此案例是流道還是遠場箱體中的物體，因此 {{count}} 個壓降目標可能沒有意義。請先設定邊界條件或選擇網格。',
    min: '最小',
    max: '最大',
    removeObjective: '移除目標',
  },
  runPlan: {
    tabulateCht: '製表各區域溫度與尖峰熱點溫度',
    tabulateCfd: '製表受力與各案例差異',
    tabulateFeaStructural: '製表應力、位移與安全係數',
    tabulateFeaModal: '製表振動模態與自然頻率',
    generateDesignPoints_one: '產生 {{count}} 個設計點',
    generateDesignPoints_other: '產生 {{count}} 個設計點',
    meshAndSolveCase_one: '網格化並求解 {{count}} 個 {{case}} 案例',
    meshAndSolveCase_other: '網格化並求解 {{count}} 個 {{case}} 案例',
    sobolSample: 'Sobol 取樣 {{samples}} 個點，涵蓋 {{ranges}} 個範圍參數',
    meshAndSolve_one: '網格化並求解 {{count}} 個案例',
    meshAndSolve_other: '網格化並求解 {{count}} 個案例',
    fitSurrogate: '在 {{responses}} 上擬合高斯過程代理模型',
    allResponses: '所有回應',
    suggestBatch: '透過 MOBO 建議下一批次以 {{goals}}',
    minimize: '最小化',
    maximize: '最大化',
    whenYouPressRun: '當你按下執行',
  },
  autoRetry: {
    label: '自動重試',
    hint: '案例失敗時，AI 會檢視失敗原因、調整求解器設定並自動重新執行。',
    maxAttempts: '每個案例的重試次數',
    meshLabel: '網格自動重試',
    meshHint:
      '幾何網格生成失敗（或完成但未達品質政策）時，AI 會檢視失敗原因、調整網格設定並自動重新執行。',
    meshMaxAttempts: '每個網格的重試次數',
  },
  sampling: {
    samples: '樣本數',
    noRanges: '至少將一個參數設定為 Range 才能使用 Sobol 取樣。',
    advanced: '進階',
    method: '方法',
    sobolSequence: 'Sobol 序列',
    seed: '種子',
    scramble: '擾動',
    scrambleTooltip:
      '對 Sobol 序列套用 Owen 擾動 — 在不失去低差異特性的前提下改善均勻性。',
    totalDesignPoints: '設計點總數',
    sobolPointsCombos: '{{samples}} 個 Sobol 點 × {{combos}} 個離散組合',
    sobolPoints: '{{samples}} 個 Sobol 點',
  },
  structural: {
    categoryFixedSupport: '固定支撐',
    categoryRollerSupport: '滾動支撐',
    categoryLoadFace: '受力面',
    categoryLoadEdge: '受力邊',
    categoryLoadPatch: '點載重',
    detailFixedSupport: '固定支撐',
    detailFixedBody: '固定物體',
    detailRestraint: '拘束',
    detailRollerSupport: '滾動支撐',
    detailFaceLoad: '面載重',
    detailPressure: '壓力',
    detailAxialCoupling: '軸向耦合',
    detailContact: '接觸',
    detailFriction: '摩擦',
    detailFrictionless: '無摩擦',
    detailBothSides: '兩側',
    detailSameContactSurfaces: '相同接觸面',
    detailCutPlanePreload: '剖面對預載',
    detailThermalShrinkPreload: '熱收縮預載',
    detailSharedMeshJoin: '共用網格接合',
    detailPointOnly: '僅點接觸',
    detailEdgeOnly: '僅邊接觸',
    detailFaces_one: '{{count}} 個面',
    detailFaces_other: '{{count}} 個面',
    loadPatch: '點載重',
    patchPlaceHint: '請在 3D 視圖中點選此面上的一點。',
    patchPlacing: '放置點',
    patchPlace: '放置點',
    patchReplace: '移動點',
    patchSnapLabel: '點位吸附',
    patchSnapNode: '網格節點',
    patchSnapFace: '面中心',
    patchSnapFacet: '表面元素',
    loadCountOnFace: '{{label}} 上有 {{count}} 個荷載',
    patchAt: '{{x}}, {{y}}, {{z}} mm',
    patchRadius: '半徑',
    patchRadiusHint:
      '對實體施加點載重會產生應力奇點：網格越細，尖峰應力就越大而不收斂。半徑讓相同的總載重分布在真實接觸面積上，結果才有意義。',
    patchNoCenterWarning: '請放置一點 — 點載重需要它。',
    categoryFree: '自由',
    collapse: '收合',
    expand: '展開',
    bcTypeFor: '{{label}} 的邊界條件類型',
    free: '自由',
    fixedSupport: '固定支撐',
    rollerSupport: '滾動支撐',
    loadFace: '受力面',
    loadEdge: '受力邊',
    pressure: '壓力',
    pressureValue: '壓力',
    nodalLoad: '節點荷載',
    bodyLoads: '本體與耦合荷載',
    gravity: '重力',
    addGravity: '新增重力',
    magnitude: '大小',
    centrifugal: '離心荷載',
    addCentrifugal: '新增離心荷載',
    axisDirection: '軸方向',
    axisPoint: '軸上一點（mm）',
    addAxialCoupling: '軸向耦合所選表面',
    selectFacesForCoupling: '選擇一個或多個表面以建立軸向耦合。',
    forceN: '力（N）',
    displacementMm: '位移（mm）',
    addLoad: '新增負載:',
    addLoadFor: '將 {{kind}} 新增至 {{label}}',
    bulkAddFaceLoad: '將面負載新增至所選面',
    contactSection: '接觸',
    frictionlessLimit:
      '除非在接觸對上設定摩擦係數，否則接觸採無摩擦模型：表面可以無阻力地滑動，這可能低估接合處的剛性，且無法模擬依靠摩擦防止滑移的接合。',
    contactSolveLimit:
      '加入接觸後，分析會成為非線性求解：表面會隨負載變化而分離或接觸。求解器可能無法找到穩定的解。',
    contactSummary: '僅傳遞壓力的接觸；可自由分離。若要傳遞剪力，請加入摩擦。',
    contactMechanicsTooltip:
      '接觸時，懲罰法會抵抗法向穿透，但允許極小的數值重疊。接觸不傳遞拉力，因此壓力降為零時表面可分離。無摩擦時可自由滑動；有摩擦時約在 μp 以下黏著，超過後滑動。若界面必須保持黏結，請使用共享節點。接觸狀態的迭代也會使求解成為非線性。',
    linearElasticLimit:
      '材料採線彈性模型，不模擬永久變形。應力超過降伏強度時，這項假設便不再成立；請勿將該數值視為實際應力的預測。',
    fastenerSection: '緊固件',
    fastenerPreload: '預緊力',
    createFastener: '新增緊固件',
    fastenerRemove: '移除緊固件 {{name}}',
    fastenerCutWarning:
      '緊固件需要一個切斷螺桿的內部表面，且切口旁的每個元素都必須有完整的面位於其上（結構化或掃掠層）。CalculiX 會讓僅以邊接觸的元素跨切口保持結合，因此一般四面體網格上的切口會被拒絕，而不是讓預緊力悄悄不足。',
    contactHint:
      '接觸僅傳遞壓力並允許表面分離 — 與同時傳遞拉力的結合網格不同。第一個面為從屬（slave）側，請選擇網格較細或較軟的一側。',
    createContact: '配對為接觸',
    contactSwap: '交換 {{name}} 的從屬側',
    contactSwapShort: '交換',
    contactRemove: '移除接觸 {{name}}',
    contactDirectionHint: '從屬（slave）→ 獨立（master）',
    independentBodiesNeedContact:
      '{{count}} 個獨立網格本體沒有接觸對。材料配置只會賦予各本體剛度與密度，不會連接本體；請為相接界面新增接觸對，或以共享節點網格建立黏結組件。',
    clampedLoadWarning:
      '此面已完全固定 — 夾持規定了每個節點的位移，因此這些負載無法作用。請移除負載，或解除此面的固定。（固定支撐承受的剪力是求解結果，而非輸入。）',
    addLoadFaceTaken: '此面已有面負載 — 請在上方編輯，或使用其力分量',
    removeLoad: '移除 {{kind}}',
    sectionFacesLoads: '{{faces}} 個面 · {{loads}} 個負載',
    noEdgesForFace: '此面沒有可用的邊界邊。',
    noEdgeSelectedWarning: '請選擇一個邊 — 受力邊需要選定邊才能套用。',
    selectedCount: '已選取 {{count}} 個',
    assignTypePlaceholder: '指定類型…',
    clear: '清除',
    body: '本體',
    fixedBody: '固定支撐',
    bodyGroup: '本體 {{index}}',
    material: '材料',
    bodiesAndMaterials: '本體與材料',
    bodiesAndMaterialsTooltip:
      '每個納入分析的體積都需要結構材料。材料提供剛度、密度與強度，但不會連接分離的本體。黏結界面請使用共享節點；獨立網格本體可能相接之處請設定接觸對。',
    targetBodies: '本體',
    targetFaces: '面',
    categoryTooltip: {
      fixed_face: '將此面所有節點的 X、Y、Z 位移設為零。反作用力是求解結果。',
      roller_face: '只限制所選位移方向；未選方向仍可自由移動。',
      load_face: '將輸入的總力分配到所選面的節點。',
      pressure: '沿表面法向施加分布牽引力。正壓力朝表面內側作用。',
      load_point: '將節點力分配到所選面；若已知實際受力面積，請使用點負載。',
      load_edge: '將輸入的總力沿一條所選邊界邊分配。',
      load_patch:
        '將輸入的總力分布於所選點周圍的圓形區域，避免理想集中力造成的應力奇異點。',
      free: '不新增拘束或負載；此面仍可參與接觸。',
    },
    materialFor: '{{name}} 的材料',
    role: {
      member: '構件',
      fastener: '緊固件',
      excluded: '已排除',
    },
    noNamedFaces:
      '找不到具名的面。在網格化前先於 MeshGen 中標記面以設定邊界條件。',
  },
  studyPreview: {
    title: '研究預覽',
    designPointsLabel_one: '個設計點',
    designPointsLabel_other: '個設計點',
    designPointsFormula: '（{{formula}}）',
    formulaManualPart_one: '手動 {{count}} 個',
    formulaManualPart_other: '手動 {{count}} 個',
    emptyState: '選擇一個檔案以預覽設計點矩陣',
    columnIndex: '#',
    columnIndexLong: '設計點 #',
    columnIndexInfo:
      '設計點 (Design Point) — 研究每執行一組案例對應一列。\n\n掃掠列由求解器設定的掃掠值直積展開產生。手動列則是使用者透過「＋ 新增設計點」加入的個別案例。\n\n點手動 DP 列即可編輯覆寫值。將游標停在列上（滑鼠停留）顯示複製 + 移除, 停在掃掠值格上顯示 ✕。',
    columnGeometry: '幾何',
    columnElements: '網格單元',
    columnMeshId: '網格 ID',
    copyMeshId: '點選以複製完整網格 ID',
    meshIdCopied: '網格 ID 已複製到剪貼簿',
    showingFirst: '顯示 {{total}} 個設計點中的前 200 個',
    inputsMesh_one: '{{count}} 個網格',
    inputsMesh_other: '{{count}} 個網格',
    inputsGeometry_one: '{{count}} 個幾何',
    inputsGeometry_other: '{{count}} 個幾何',
    inputsMixed: '{{count}} 個輸入',
    addManualDp: '新增設計點',
    addManualDpTitle: '新增設計點',
    editManualDpTitle: '編輯設計點',
    saveManualDp: '儲存',
    editingBanner: '正在編輯 DP：{{label}}',
    doneEditing: '完成',
    editingSweepHint:
      '下方掃掠欄位的變更會套用到掃掠, 不會影響此 DP。要編輯此 DP 的個別覆寫值請在 DP 彈出視窗中修改。',
    viewingStudyDefaults: '正在檢視研究預設值',
    viewingSweepHint:
      '這裡編輯的欄位會成為整個研究的基準值, 每個沒有覆寫該軸的設計點都會沿用這些值。',
    editingChipTooltip:
      '有一個手動 DP 被聚焦中。此 DP 除了彈出視窗中被覆寫的軸之外, 其餘均沿用研究預設值。掃掠欄位的編輯仍會影響掃掠列表, 不會影響此 DP。點 × 結束。',
    viewingChipTooltip:
      '預設編輯模式。這裡編輯的每一項會成為整個研究的基準值 — 套用到每個沒有覆寫該軸的 DP。',
    manualDpInput: '輸入',
    inputKindGeometry: '幾何',
    inputKindMesh: '網格',
    tagSweep: '掃掠',
    tagManual: '手動',
    sweepRowFocusTitle: '正在檢視掃掠列',
    sweepRowFocusHint:
      '以下的編輯 (流體・邊界條件・求解器) 會套用於 **所有掃掠列** — 掃掠列是所有參數的組合排列, 不是獨立點. 若要以獨立設定固定單一點, 請透過「新增設計點」建立手動 DP.',
    sweepRowFocusExit: '返回研究預設值',
    tooltipInherit: '沿用研究預設值',
    tooltipUnique: '唯一',
    tooltipSharedWith: '與 {{rows}} 共用',
    removeSweepValue: '移除此掃掠值',
    removeSweepValueTooltip: '從 {{path}} 移除 {{value}}',
    manualDpOverrides: '覆寫值',
    manualDpInherit: '沿用',
    manualDpLabel: '標籤（選填）',
    manualDpLabelPlaceholder: '例如：fast, open, 最壞情境',
    duplicateDp: '複製設計點',
    duplicateAsManual: '複製為手動 DP',
    manualDpColor: '顏色',
    removeManualDp: '移除此設計點',
    manualDpChip_one: '手動 {{count}} 個',
    manualDpChip_other: '手動 {{count}} 個',
    multiSelectHintAria: 'DP 表格的多選功能說明',
    multiSelectHint:
      '在手動 DP 列上 Ctrl / Cmd + 點擊即可加入選取. Shift + 點擊延伸範圍選取. Ctrl / Cmd + A 全選所有可見的手動 DP. Delete / Backspace 移除選取, Escape 清除選取.\n\n目前多選僅支援手動 DP. 掃掠 DP 共用軸清單, 因此無法只移除特定的組合 (例如第 4 列 = 速度=1 × 壓力=20) — 資料模型不支援. 已列為後續項目 (BE: excluded_dp_signatures).',
    multiSelectSelected_one: '已選 {{count}} 個',
    multiSelectSelected_other: '已選 {{count}} 個',
    multiSelectDelete: '刪除',
    multiSelectClear: '清除',
    selectAllManual: '全選',
    multiSelectStatusChip_one: '已選 {{count}} 個 DP',
    multiSelectStatusChip_other: '已選 {{count}} 個 DP',
    multiSelectChipTooltip_one:
      '目前多選 {{count}} 個手動 DP. 側邊欄的變更會套用到整個研究 (或掃掠), 不會修改選取中的 DP. 刪除選取請按 Delete 鍵或「手動」標籤旁的刪除按鈕. 按 × 清除選取.',
    multiSelectChipTooltip_other:
      '目前多選 {{count}} 個手動 DP. 側邊欄的變更會套用到整個研究 (或掃掠), 不會修改選取中的 DP. 刪除選取請按 Delete 鍵或「手動」標籤旁的刪除按鈕. 按 × 清除選取.',
    multiSelectSidebarHint_one:
      '側邊欄的編輯仍套用到研究預設值 / 掃掠, 不會修改已選取的 {{count}} 個 DP. 使用刪除按鈕或 Delete 鍵移除選取, Escape 清除.',
    multiSelectSidebarHint_other:
      '側邊欄的編輯仍套用到研究預設值 / 掃掠, 不會修改已選取的 {{count}} 個 DP. 使用刪除按鈕或 Delete 鍵移除選取, Escape 清除.',
    cancel: '取消',
  },
  bcValidation: {
    unsetOpening:
      '請為 {{patches}} 選擇流向。網格器偵測到這些是流動開口，但無法判斷流動方向。若未設定，這些開口會被封閉，計算結果會少於 CAD 實際的開口數量。',
    missingInlet:
      '至少選擇一個面片作為速度入口（或自由流），讓求解器知道流動從何進入。',
    missingOutlet:
      '至少選擇一個面片作為壓力出口（或自由流）。若沒有，壓力方程無界，求解器會發散。',
    patchMismatch:
      '面片「{{patch}}」不在目前的網格中 — 請重新選擇角色或移除該列。',
    zeroInletVelocity:
      '請將整體研究的入口速度（物理設定中的 Inlet · 速度）設為大於 0 的值 — 僅設定單一面片列的值無法清除此警告。預設的 0 只是佔位值，研究無法以此執行。',
    zeroPatchVelocity:
      '請將面片「{{patch}}」的速度設為大於 0 的值 — 0 只是佔位值，研究無法以此執行。',
    jumpToField: '跳至該欄位',
  },
} as const;
